import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetValidateAllPages = createAsyncThunk(
  "AllPagesValidation/ValidateAllPages",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AllPagesValidation/ValidateAllPages",
        {
            aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
    //   if (response.data.success === true) {
    //     const arrayValidate = response.data.result.map((ele, ind) => {
    //       return ele.code;
    //     });
    //     return arrayValidate; // Return the extracted data
    //   }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ValidateAllPages = createSlice({
  name: "ValidateAllPages",
  initialState: {
    ValidateAllPages: {},
    loadingValidateAllPages: false,
    errorValidateAllPages: null,
  },
  reducers: {
    SetValidateAllPages: (state, action) => {
      state.ValidateAllPages = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetValidateAllPages.pending, (state, action) => {
        state.loadingValidateAllPages = true;
        state.ValidateAllPages = action.payload;
        state.errorValidateAllPages = null;
      })
      .addCase(GetValidateAllPages.fulfilled, (state, action) => {
        state.loadingValidateAllPages = false;
        state.ValidateAllPages = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetValidateAllPages.rejected, (state, action) => {
        state.loadingValidateAllPages = false;
        state.errorValidateAllPages = action.payload;
      });
  },
});
export const { SetValidateAllPages } = ValidateAllPages.actions;

export default ValidateAllPages.reducer;
